import { render, staticRenderFns } from "./ClientExportDetails_Details.vue?vue&type=template&id=f609b40a&"
import script from "./ClientExportDetails_Details.vue?vue&type=script&lang=js&"
export * from "./ClientExportDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports